import officeState from "../office/state.ts";
import Alpine from "alpinejs";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { bindFormUpdate, pipeline } from "../handlers/updates.ts";
import { IDownloadCompleted } from "../global";


export default class AutoUpload extends AlpineComponent {
  // @ts-ignore
  private form: HTMLFormElement;
  // @ts-ignore
  private fileInput: HTMLInputElement;

  constructor(
    public devMode = false,
    public uploading = true,
    public docId: string | undefined = undefined,
    public returnUrl: string | undefined = undefined
  ) {
    super();
  }

  init() {
    this.form = this.$el as HTMLFormElement;
    bindFormUpdate(this.form)
    this.fileInput = this.$refs.fileInput as HTMLInputElement;
    this.docId = (
      this.$el.querySelector("input[name='preferredDocId']") as HTMLInputElement
    )?.value;
    this.returnUrl = (
      this.$el.querySelector("input[name='returnUrl']") as HTMLInputElement
    )?.value;
    Alpine.effect(this.autoLoad.bind(this));
  }


  private autoLoad() {
    // Microsoft Office
    if (officeState.enabled && officeState.loaded) {
      return this.officeAutoUpload();
    }

    this.uploading = false;
  }

  async officeAutoUpload() {
    try {
      this.uploading = true;
      await pipeline.update()
    } catch (e) {
      console.error(e);
    }
  }

  onNewDocument(e: CustomEvent<IDownloadCompleted>) {
    const { files } = e.detail;
    this.fileInput.files = files;
    this.form.submit()
  }

  onAfterSettle() {
    this.uploading = false;
  }

  onClick() {
    this.$refs.fileInput.click();
  }

  onSubmit() {
    this.uploading = true;
  }

  onChange() {
    if (this.fileInput.files && this.fileInput.files.length > 0) {
      this.uploading = true;
      this.form.submit();
    }
  }
}
